var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoKotlin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#7f6cb1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h61.4l-61.4 60.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 128 128-128h-63.4l-64.6 63.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128 128-63.4-61.4-61.3 61.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKotlin);
export default __webpack_public_path__ + "static/media/logo-kotlin.6d108dcd884eb40d0197a78e0a6fca62.svg";
export { ForwardRef as ReactComponent };